import invariant from 'invariant'
import mixpanel from 'mixpanel-browser'
import { useAsyncHandler } from 'react-hooks-async-handlers'
import { load } from 'recaptcha-v3'
import config from '../../../config'
import { OnboardCreatePayload } from '../../../generated-api/data-contracts'
import analytics from '../../../libs/analytics'
import api from '../../../libs/api'
import store from '../../../store'

export type OnboardFormData = {
  full_name: string
  password: string
  company_name: string
  is_eula_accepted: boolean
  asset_id?: string
  locations: [{ name: string; code: string }]
  identity_verification_id?: string
}

function useOnboardAction(state: OnboardFormData) {
  const onboardAction = useAsyncHandler(async () => {
    const storeState = store.getState()
    const { email, phone_number } = storeState.form
    invariant(phone_number, 'phone_number is not set')

    let {
      full_name,
      password,
      company_name,
      is_eula_accepted,
      asset_id,
      locations: locationsRaw,
      identity_verification_id,
    } = state

    const recaptcha = await load(config.recaptchaSiteKey)
    const recaptchaToken = await recaptcha.execute('onboard')

    const locations = _.map(locationsRaw, (loc) => loc.code)

    const distinctId = mixpanel.get_distinct_id()

    const gclid = localStorage.getItem('gclid')

    const onboardPayload: OnboardCreatePayload = {
      email,
      full_name,
      password,
      company_name,
      is_eula_accepted,
      locations,
      phone_number,
      identity_check_id: identity_verification_id,
      distinct_id: distinctId,
      // @ts-ignore
      recaptcha: recaptchaToken,
      gclid,
    }

    if (asset_id) onboardPayload.asset_id = asset_id

    const response = await api.onboardCreate(onboardPayload)
    const { agent_id } = response?.data || {}
    if (agent_id) {
      analytics.identify(agent_id, { name: full_name })
      // mixpanel.identify(email)
      // mixpanel.track('Sign Up', {
      //   'Signup Type': 'Referral',
      // })
    }
  })

  return onboardAction
}

export default useOnboardAction
